import type {FC} from 'react'
import {useQuery} from 'react-query'
import {getListMemberCycleByMemberId, getListMemberCycleDetail} from '../../../../modules/services/member.service'
import {useParams} from 'react-router-dom'

interface Props {
  data: any
}

const DetailCycle: FC<Props> = ({data}) => {
  const {id} = useParams<{id: string}>()
  const {data: memberCycle} = useQuery(['getListMemberCycleByMemberId', id], () =>
  getListMemberCycleDetail(id as string)
  )
  const ongoingMemberCycle = (memberCycle?.data as Array<any>)?.find((mc) => mc.attributes.cycle.data.id === data?.attributes?.ongoing_cycle?.data.id)
  const passedMemberCycle = (memberCycle?.data as Array<any>)?.filter((mc) => mc.attributes.status === "passed") ?? []
  return (
    <div className='col'>
      {data?.attributes?.ongoing_cycle?.data && passedMemberCycle.length !== 6 && (
        <div className='col py-6'>
          <div className='d-flex align-items-center gap-4'>
            <div className='bg-primary rounded-circle' style={{width: '12px', height: '12px'}} />
            <h4 className='fw-bold mb-0'>
              Cycle {data?.attributes?.ongoing_cycle?.data.attributes?.cycle} - {' '}
              {data?.attributes?.ongoing_cycle?.data.attributes?.name}
            </h4>
            <span className='badge badge-outline badge-primary'>Ongoing</span>
          </div>
          <div className='col ms-8 py-2'>
            <div className='d-flex gap-2'>
              <h4 className='fs-6 fw-bold'>Start Cycle:</h4>
              <p className='fs-6 ms-8'>{ongoingMemberCycle?.attributes?.startedAt}</p>
            </div>
            <div className='d-flex gap-2'>
              <h4 className='fs-6 fw-bold'>Member Term:</h4>
              <p className='fs-6 ms-8'>{ongoingMemberCycle?.attributes?.memberTerms} Days</p>
            </div>
            {/* <div className='d-flex gap-2'>
              <h4 className='fs-6 fw-bold'>Push Reminder History:</h4>
              <div className='col'>
                <p className='fs-6 ms-8'>+ 02 - 04 - 2022 08.34 WIB</p>
                <p className='fs-6 ms-8'>+ 05 - 05 - 2022 09.34 WIB</p>
              </div>
            </div> */}
          </div>
        </div>
      )}
      {(passedMemberCycle as any[])?.map((cycle, index) => {
        return (
           cycle && (
             <div key={index} className='col py-6'>
               <div className='d-flex align-items-center gap-4'>
                 <div
                   className='bg-primary rounded-circle'
                   style={{width: '12px', height: '12px'}}
                 />
                 <h4 className='fw-bold mb-0'>
                   Cycle {cycle?.attributes?.cycle?.data?.attributes?.cycle} - {cycle?.attributes?.cycle?.data?.attributes?.name}
                 </h4>
                 <span className='badge badge-outline badge-success'>Done</span>
               </div>
               <div className='col ms-8 py-2'>
                  {/* <div className='d-flex gap-2'>
                   <h4 className='fs-6 fw-bold'>Week:</h4>
                   <p className='fs-6 ms-8'>
                     {
                       cycle?.attributes?.activityCount
                     }
                   </p>
                  </div> */}
                  <div className='d-flex gap-2'>
                    <h4 className='fs-6 fw-bold'>Start Cycle:</h4>
                    <p className='fs-6 ms-8'>{cycle?.attributes?.startedAt}</p>
                  </div>
                  <div className='d-flex gap-2'>
                    <h4 className='fs-6 fw-bold'>Member Term:</h4>
                    <p className='fs-6 ms-8'>{cycle?.attributes?.memberTerms} Days</p>
                  </div>
               </div>
            </div>
         )
        )
      }
      )}
    </div>
  )
}

export default DetailCycle
